import React, { useState } from "react";
import EditEducationIndex from "./Components/EditCategory/EditCategory";
import useCategory from "./useCategory";
import EditImg from "../../images/SideBar/Edit";
import Loader from "../../components/Loader";
import CommonDataGrid from "../../components/CommonDataGrid";
import Button from "../../components/Botton";
import { Toaster } from "react-hot-toast";
import { GridColDef } from "@mui/x-data-grid";
import { TextField } from "@mui/material";
import DeleteImg from "../../images/SideBar/Delete";
import ConfirmationModal from "../../components/ConfirmationModal/ConfirmationModal";
import { getSortByTimeButtonText } from "../../util/getSortByTimeText";

const Category: React.FC = () => {
  const columns: GridColDef[] = [
    {
      field: "category",
      headerName: "Category",
      align: "center",
      headerAlign: "center",
      flex: 1,
      filterable: true,
      sortable: true,
    },
    {
      field: "Actions",
      headerName: "Actions",
      align: "center",
      headerAlign: "center",
      flex: 0.8,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <div className="flex h-full items-center justify-center">
          <button
            onClick={() => handleEdit(params.row._id, params.row.category)}
            className="text-fontColor hover:text-primary-2"
          >
            <EditImg />
          </button>
          <button
            onClick={() => openDeleteModal(params.row._id)}
            className="text-fontColor hover:text-red-500"
          >
            <DeleteImg />
          </button>
        </div>
      ),
    },
  ];

  const {
    selectedEducationId,
    selectedEducationName,
    educationData,
    loading,
    searchQuery,
    setSearchQuery,
    handleEdit,
    handleDelete,
    handleStatusUp,
    handleDateFilter,
    setFilterModel,
    setSortingModel,
    paginationModel,
    setPaginationModel,
    rowCount,
    handleAdd,
    // New time sort items
    handleSortByTime,
    timeSortOrder,
  } = useCategory(columns);

  const [isModalOpen, setIsModalOpen] = useState(false); // Modal open state
  const [educationToDelete, setEducationToDelete] = useState<string | null>(null);

  const openDeleteModal = (id: string) => {
    setEducationToDelete(id);
    setIsModalOpen(true);
  };

  const confirmDelete = () => {
    if (educationToDelete) {
      handleDelete(educationToDelete);
      setIsModalOpen(false);
    }
  };

  const closeDeleteModal = () => {
    setIsModalOpen(false);
    setEducationToDelete(null);
  };

  const handleEditComplete = () => {
    // Reset the edit state to close the modal
    handleEdit("", "");
  };

  return (
    <div className="mx-auto p-4">
      {loading && <Loader />}
      {selectedEducationId ? (
        <EditEducationIndex
          educationId={selectedEducationId}
          name={selectedEducationName}
          onEditComplete={handleEditComplete}
        />
      ) : (
        <div className="space-y-4 mt-4 bg-white p-4 rounded-b-lg shadow-md">
          <div className="flex justify-between items-center gap-4 mr-1 mb-4">
            <TextField
              fullWidth
              variant="outlined"
              label="Search"
              placeholder="Search By"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              size="small"
              sx={{ maxWidth: '400px' }}
            />
            <div className="flex gap-4">
              <Button
                onClick={handleSortByTime}
                className="py-1.5 px-9 rounded"
                children={getSortByTimeButtonText(timeSortOrder)}
                type="button"
              />
              <Button
                onClick={handleAdd}
                className="py-1.5 px-9 rounded"
                children="Add Category"
                type="button"
              />
            </div>
          </div>
          <CommonDataGrid
            id="category"
            rows={educationData}
            columns={columns}
            loading={loading}
            showConfirmation={false}
            confirmationMessage={""}
            setFilterModel={setFilterModel}
            setSortingModel={setSortingModel}
            paginationMode="server"
            rowCount={rowCount}
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            onCancelDelete={function (): void {
              throw new Error("Function not implemented.");
            }}
            onConfirmDelete={function (): void {
              throw new Error("Function not implemented.");
            }}
            toolbarProps={{ toolbar: { showQuickFilter: true } }}
          />
        </div>
      )}
      <ConfirmationModal
        isOpen={isModalOpen}
        onClose={closeDeleteModal}
        onConfirm={confirmDelete}
        message="Are you sure you want to delete this Category?"
      />
      <Toaster />
    </div>
  );
};

export default Category;
